/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import axios from '../services/ApiService';
import i18n from '../utils/i18n';

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'focus-within-polyfill';
import 'scripts/confirm';
import { Modal } from 'scripts/modal';
import { WishListsLoader } from 'scripts/wish_lists_loader';
import { initTooltips, watchTooltips } from 'scripts/tooltips';
import 'scripts/carousel_wizard';

// Material Design Styles
import '../stylesheets/material-styles.scss';

// routers
import { router } from '../router/index.js'

// Vue Components
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { createBootstrap } from 'bootstrap-vue-next'
import App from '../components/App.vue';
import AdvancedSearch from '../components/AdvancedSearch.vue';
import CohortPage from '../components/CohortPage.vue';
import UsersManagement from '../components/UsersManagement.vue';
import LibraryCatalog from '../components/library_catalog/LibraryCatalog.vue';
import Imprints from '../components/imprints/Imprints.vue';
import PublishersBrowse from '../components/browse/PublishersBrowse.vue';
import SalesAnalyticsDashboard from '../components/sales_analytics/SalesAnalyticsDashboard.vue';
import SalesDashboard from '../components/sales_dashboard/SalesDashboard.vue';
import ImportationHistory from '../components/ImportationHistory.vue';
import FiltrableSelect from '../components/ui/FiltrableSelect.vue';
import SearchComponent from '../components/ui/SearchComponent.vue';
import SearchableSelect from '../components/ui/SearchableSelect.vue';
import ScheduledCartCriteria from '../components/scheduled_cart/ScheduledCartCriteria.vue';
import CarouselCriteria from '../components/carousel/CarouselCriteria.vue';
import ClassificationTree from '../components/ClassificationTree.vue';
import UnsafeExclusionPicker from '../components/ui/UnsafeExclusionPicker.vue';

// Initialization
document.addEventListener('DOMContentLoaded', (event) => {
  // Initialize Bootstrap tooltips, then keep them in sync with the DOM so tooltips
  // rendered by Vue or loaded over AJAX work without any per-component wiring.
  initTooltips();
  watchTooltips();

  if (document.getElementById('vue-app')) {
    const pinia = createPinia();
    const app = createApp(App);

    app.use(router);
    app.use(pinia);
    app.use(i18n);

    pinia.use(({ store }) => {
      store.$axios = axios
    });
    pinia.use(piniaPluginPersistedstate);
    app.use(createBootstrap());
    app.mount('#vue-app');
  }

  const vas = document.getElementById('vue-advanced-search');
  if (vas) {
    var jsonData = {};
    if (vas.dataset.json) {
      jsonData = JSON.parse(vas.dataset.json);
    }

    const advancedSearchApp = createApp(AdvancedSearch, jsonData);

    advancedSearchApp.use(i18n);
    advancedSearchApp.use(createBootstrap());

    advancedSearchApp.mount(vas);
  }

  const vcp = document.getElementById('vue-cohort-page');
  if (vcp) {
    var jsonData = {};
    if (vcp.dataset.json) {
      jsonData = JSON.parse(vcp.dataset.json);
    }

    const cohortPageApp = createApp(CohortPage, jsonData);

    cohortPageApp.use(i18n);
    cohortPageApp.use(createBootstrap());

    cohortPageApp.mount(vcp);
  }

  const vum = document.getElementById('vue-users-management');
  if (vum) {
    const pinia = createPinia();
    const jsonData = JSON.parse(vum.dataset.json);
    const usersManagementApp = createApp(UsersManagement, jsonData);
    usersManagementApp.use(i18n);
    usersManagementApp.use(pinia);
    pinia.use(({ store }) => {
      store.$axios = axios
    });
    pinia.use(piniaPluginPersistedstate);
    usersManagementApp.use(createBootstrap());
    usersManagementApp.mount(vum);
  }

  const vlc = document.getElementById('vue-library-catalog');
  if (vlc) {
    const jsonData = JSON.parse(vlc.dataset.json);
    const libraryCatalogApp = createApp(LibraryCatalog, jsonData);
    libraryCatalogApp.use(i18n);
    libraryCatalogApp.use(createBootstrap());
    libraryCatalogApp.mount(vlc);
  }

  const vimprints = document.getElementById('vue-imprints-list');
  if (vimprints) {
    const jsonData = JSON.parse(vimprints.dataset.json);
    const imprintsApp = createApp(Imprints, jsonData);
    imprintsApp.use(i18n);
    imprintsApp.use(createBootstrap());
    imprintsApp.mount(vimprints);
  }

  const vpublishersbrowse = document.getElementById('vue-publishers-browse');
  if (vpublishersbrowse) {
    const jsonData = JSON.parse(vpublishersbrowse.dataset.json);
    const publishersBrowseApp = createApp(PublishersBrowse, jsonData);
    publishersBrowseApp.use(i18n);
    publishersBrowseApp.mount(vpublishersbrowse);
  }

  const vsa = document.getElementById('vue-sales-analytics');
  if (vsa) {
    const jsonData = JSON.parse(vsa.dataset.json);
    const salesAnalyticsApp = createApp(SalesAnalyticsDashboard, jsonData);
    salesAnalyticsApp.use(i18n);
    salesAnalyticsApp.use(createBootstrap());
    salesAnalyticsApp.mount(vsa);
  }

  const vsd = document.getElementById('vue-sales-dashboard');
  if (vsd) {
    const jsonData = JSON.parse(vsd.dataset.json);
    const salesDashboardApp = createApp(SalesDashboard, jsonData);
    salesDashboardApp.use(i18n);
    salesDashboardApp.use(createBootstrap());
    salesDashboardApp.mount(vsd);
  }

  const ih = document.getElementById('vue-importation-history');
  if (ih) {
    const jsonData = JSON.parse(ih.dataset.json);
    const importationHistoryApp = createApp(ImportationHistory, jsonData);
    importationHistoryApp.use(i18n);
    importationHistoryApp.use(createBootstrap());
    importationHistoryApp.mount(ih);
  }

  const vscc = document.getElementById('vue-scheduled-cart-criteria');
  if (vscc) {
    const jsonData = vscc.dataset.json ? JSON.parse(vscc.dataset.json) : {};
    const scheduledCartCriteriaApp = createApp(ScheduledCartCriteria, jsonData);
    scheduledCartCriteriaApp.use(i18n);
    scheduledCartCriteriaApp.use(createBootstrap());
    scheduledCartCriteriaApp.mount(vscc);
  }

  const vcc = document.getElementById('vue-carousel-criteria');
  if (vcc) {
    const jsonData = vcc.dataset.json ? JSON.parse(vcc.dataset.json) : {};
    const carouselCriteriaApp = createApp(CarouselCriteria, jsonData);
    carouselCriteriaApp.use(i18n);
    carouselCriteriaApp.use(createBootstrap());
    carouselCriteriaApp.mount(vcc);
  }

  const ct = document.getElementById('vue-classification-tree');
  if (ct) {
    const jsonData = JSON.parse(ct.dataset.json);
    const classificationTreeApp = createApp(ClassificationTree, jsonData);
    classificationTreeApp.use(i18n);
    classificationTreeApp.use(createBootstrap());
    classificationTreeApp.mount(ct);
  }

  window.initializeSearchableSelect = function() {
    document.querySelectorAll('.searchable-select').forEach(function(searchable_select) {
      var jsonData = {};
      if (searchable_select.dataset.json) {
        jsonData = JSON.parse(searchable_select.dataset.json);
      }
      const serchableSelectApp = createApp(
        SearchableSelect,
        jsonData
      );
      serchableSelectApp.use(i18n);
      serchableSelectApp.mount(searchable_select);
    });
  }

  document.querySelectorAll('.filtrable-select').forEach(function(filtrable_select) {
    var jsonData = {};
    if (filtrable_select.dataset.json) {
      jsonData = JSON.parse(filtrable_select.dataset.json);
    }
    const filtrableSelectApp = createApp(FiltrableSelect, jsonData);
    filtrableSelectApp.use(i18n);
    filtrableSelectApp.mount(filtrable_select);
  });

  document.querySelectorAll('.vue-unsafe-exclusion-picker').forEach(function(picker) {
    const jsonData = picker.dataset.json ? JSON.parse(picker.dataset.json) : {};
    const unsafeExclusionPickerApp = createApp(UnsafeExclusionPicker, jsonData);
    unsafeExclusionPickerApp.use(i18n);
    unsafeExclusionPickerApp.mount(picker);
  });

  document.querySelectorAll('.search-component').forEach(function(search_component) {
    const SearchComponentApp = createApp(SearchComponent, { advanced_search_url: search_component.dataset.advancedSearchUrl });
    SearchComponentApp.use(i18n);
    SearchComponentApp.mount(search_component);
  });

  // Material Component Initialization
  window.x = {};
  window.x.formInitializer = function () {

    // input file
    const $inputFiles = document.querySelectorAll('input[type="file"]');
    $inputFiles.forEach(($inputFile) => {
      $inputFile.addEventListener('change', (event) => {
        if (event.target.nextElementSibling && event.target.nextElementSibling.nextElementSibling) {
          event.target.nextElementSibling.nextElementSibling.innerHTML = event.target.files[0].name;
        }
      });
    });

    window.x.modals = [].map.call(document.querySelectorAll('.mkt-modals'), $modal => new Modal($modal));

    window.x.findModal = (identifier) => {
      return window.x.modals.find(modal => modal.identifier == identifier)
    }
  }

  window.x.formInitializer();

  if (document.querySelector('.browse__items')) {
    if (localStorage.getItem('browseItemsState') == 'list') {
      document.querySelector('.browse__items').classList.remove('browse__items--grid');
    }
    if (localStorage.getItem('browseItemsState') == 'grid') {
      document.querySelector('.browse__items').classList.add('browse__items--grid');
    }
  }

  document.querySelectorAll('.view-toggle__list').forEach(function(button) {
    button.addEventListener('click', function() {
      document.querySelector('.browse__items').classList.remove('browse__items--grid');
      localStorage.setItem('browseItemsState', 'list');
    });
  });
  document.querySelectorAll('.view-toggle__grid').forEach(function(button) {
    button.addEventListener('click', function() {
      document.querySelector('.browse__items').classList.add('browse__items--grid');
      localStorage.setItem('browseItemsState', 'grid');
    });
  });

  document.querySelectorAll('.submit-form').forEach(function(button) {
    button.addEventListener('click', function() {
      button.parentNode.parentNode.classList.add('submitting');
    });
  });

  document.querySelectorAll('.facet-toggler').forEach(function(facetToggler) {
    facetToggler.addEventListener('click', function() {
      facetToggler.parentElement.classList.toggle('facet__group--closed');
    });
  });

  const $explanationToggle = document.getElementById('explanation-toggler');
  if ($explanationToggle) {
    $explanationToggle.addEventListener('click', function(event) {
      $explanationToggle.parentElement.classList.toggle('explanation__group--closed');
    });
  }

  if (document.querySelector('.browse-facets')) {
    document.querySelectorAll('.facet__multiselect').forEach(function(facetMultiselect) {
      var applyButton = facetMultiselect.querySelector('.facet__apply');
      var parameter = facetMultiselect.dataset.parameter;

      applyButton.addEventListener('click', function() {
        let choices = [];
        facetMultiselect.querySelectorAll('input').forEach(function(checkbox) {
          if (checkbox.checked) {
            choices.push(checkbox.value);
          }
        })

        if (choices.length > 0 && typeof posthog !== 'undefined') {
          var choicesString = choices.join('-');
          posthog.capture('catalog-facet-' + parameter + '-' + choicesString);
        }

        let url = new URL(applyButton.dataset.target)
        url.searchParams.delete(parameter);
        url.searchParams.append(parameter, choices.join());

        window.location.href = url.toString();
      });
    });

    var $langFacets = document.querySelector('.browse-facets').getElementsByClassName('multi-lang-active')[0];
    if ($langFacets) {
      var $all = document.querySelector('.browse-facets').querySelector('#lang-facet__all');
      var $notAll = document.querySelector('.browse-facets').querySelectorAll('.langs-not-all');

      if ($notAll) {
        $notAll.forEach(function($checkbox) {
          $checkbox.addEventListener('change', function() {
            if(this.checked == true) {
              $all.checked = false;
            }
          })
        })
      }

      if ($all) {
        $all.addEventListener('change', function () {
          if(this.checked == true) {
            document.querySelector('.browse-facets').querySelectorAll('.langs-not-all').forEach(function ($checkbox){
              $checkbox.checked = false;
            })
          }
        })
      }

      var $langFacetsButton = document.querySelector('.browse-facets').querySelector('#facetLangButton');
      if ($langFacetsButton) {
        $langFacetsButton.addEventListener('click', function() {
          let langParams = [];
          let $langOptions = document.querySelector('.browse-facets').querySelectorAll('.langOption');
          $langOptions.forEach(function($checkbox) {
            if ($checkbox.checked) {
              langParams.push($checkbox.value);
            }
          })

          if (langParams.length > 0 && typeof posthog !== 'undefined') {
            var langParamsString = langParams.join('-');
            posthog.capture('catalog-facet-language-' + langParamsString);
          }

          let url = new URL($langFacetsButton.dataset.target)
          url.searchParams.delete('languages');
          url.searchParams.append('languages', langParams.join());

          window.location.href = url.toString();
        })
      }

      $langFacets.querySelectorAll('.more-lang-option').forEach(function(moreLangOption) {
        let $displayedLanguages = $langFacets.querySelector('.displayed-languages');
        moreLangOption.addEventListener('click', function(event) {
          let value = event.target.getAttribute('href').replace('#', '');
          let label = event.target.textContent;
          let $newOption = document.createElement("li");
          $newOption.className = "row mb-2";
          $newOption.innerHTML = `<div class="col"><div class="form-check"><input type="checkbox" name="languages" class="form-check-input langOption langs-not-all" id="lang-facet__${value}" value="${value}" checked><label class="form-check-label" for="lang-facet__${value}">${label}</label></div></div>`;
          $displayedLanguages.append($newOption);
          event.target.parentElement.remove();
          event.preventDefault();
          document.querySelector('#lang-facet__all').checked = false;
          document.querySelector(`#lang-facet__${value}`).addEventListener('change', function () {
            if (this.checked == true) {
              $all.checked = false;
            }
          })
        });
      });
    }

    const facetsPurchased = document.querySelectorAll('.facet-purchased-form');
    const facetCheckboxesIds = ['#available_in_inventory_checkbox_days_remaining', '#available_in_inventory_checkbox_loans_remaining']
    const facetInputTextIds = ['#available_in_inventory_text_days_remaining', '#available_in_inventory_text_loans_remaining']
    const verifyCheckboxes = (button, checkboxes, textFields) => {
      const buttonDisabled = checkboxes.some((checkbox, index) => checkbox.checked && textFields[index].value);
      button.disabled = !buttonDisabled;
    };

    const handleFormSubmit = (event, currentUrl) => {
      event.preventDefault();
      const form = event.target;
      const checkboxes = facetCheckboxesIds.map(selector => form.querySelector(selector));
      const textFields = facetInputTextIds.map(selector => form.querySelector(selector));

      currentUrl.searchParams.delete('days_remaining');
      currentUrl.searchParams.delete('loans_remaining');
      textFields.forEach((textField, index) => {
        if (checkboxes[index].checked && textField.value) {
          currentUrl.searchParams.set(textField.name, textField.value);
        }
      });

      window.location.href = currentUrl;
    };

    const setupFacetPurchased = (facetPurchased) => {
      const currentUrlWithParams = new URL(window.location.href);
      const button = facetPurchased.querySelector('button');
      const checkboxes = facetCheckboxesIds.map(selector => facetPurchased.querySelector(selector));
      const textFields = facetInputTextIds.map(selector => facetPurchased.querySelector(selector));

      const updateCheckboxes = () => verifyCheckboxes(button, checkboxes, textFields);

      checkboxes.forEach((checkbox) => {
        checkbox.addEventListener('change', updateCheckboxes);
      });

      textFields.forEach((textField) => {
        textField.addEventListener('input', () => {
          // Allow only numeric input
          textField.value = textField.value.replace(/\D/g, '');
          updateCheckboxes();
        });
      });

      updateCheckboxes();

      facetPurchased.addEventListener('submit', (event) => handleFormSubmit(event, currentUrlWithParams));
    };

    facetsPurchased.forEach(setupFacetPurchased);

  }

  document.querySelectorAll('.facet__more').forEach(function(moreDisplay) {
    moreDisplay.addEventListener('click', function() {
      moreDisplay.parentElement.classList.remove('facet__group--hidden-ninjas');
    });
  });

  document.querySelectorAll('.dlp__line').forEach(function(openUp) {
    openUp.addEventListener('click', function() {
      openUp.parentElement.classList.add('dlp__open-up');
    });
  });

  document.querySelectorAll('.item__ot-button').forEach(function($openUp) {
    $openUp.addEventListener('click', function(event) {
      event.preventDefault();
      let row = document.querySelector(".item__table[data-offer-id='" + $openUp.getAttribute('data-offer-id') + "']");
      row.classList.toggle('d-none');
    });
  });

  document.querySelectorAll('.editable-invoice-status').forEach(($form, i) => {
    $form.querySelector('.invoice-status-select').addEventListener('change', (event) => {
      $form.classList.remove('show-success', 'show-failure');
      $form.classList.add('show-spinner');

      let url = $form.getAttribute('action');
      let payload = {
        invoice_status: event.target.value
      };
      new Ajax().patch(url, { data: payload },
        function(data) {
          $form.classList.remove('show-spinner');
          $form.classList.add('show-success');
        },
        function(error) {
          $form.classList.remove('show-spinner');
          $form.classList.add('show-failure');

          alert(error['message']);
        }
      );
    });
  });

  window.initializeSearchableSelect();

  new WishListsLoader();
});
